// extracted by mini-css-extract-plugin
module.exports = {"checked":"CheckBox_checked__2IRdz","unchecked":"CheckBox_unchecked__3Ih_-"};